import { render, staticRenderFns } from "./RowDetailsDialog.vue?vue&type=template&id=3ed3c8dc&scoped=true"
import script from "./RowDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./RowDetailsDialog.vue?vue&type=script&lang=ts"
import style0 from "./RowDetailsDialog.vue?vue&type=style&index=0&id=3ed3c8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed3c8dc",
  null
  
)

export default component.exports